import { AfterViewChecked, Component, ElementRef, HostListener, SimpleChanges, ViewChild } from '@angular/core';
import { ConfirmEventType, ConfirmationService, Message, MessageService, TreeNode } from 'primeng/api';
import { breadcrumb, link, stat } from 'src/app/admin/layout/header/header.component';
import { data_fields, data_item } from 'src/app/misc/interface/data';
import { DataService } from 'src/app/services/data.service';
import { DataView } from 'primeng/dataview';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { MenuItem } from 'src/app/misc/interface/menu-item';
import cloneDeep from 'lodash/cloneDeep';
import { ExportService } from 'src/app/services/export.service';
import { convert } from 'html-to-text'

@Component({
  selector: 'app-content-update-page',
  templateUrl: './content-update-page.component.html',
  styleUrls: ['./content-update-page.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class ContentUpdatePageComponent implements AfterViewChecked {
handlechange($event: any) {
  console.log($event)
}
filterFunctionByPostOuFilter($event: any) {
 this.oufilter = $event.node;
}

  @ViewChild('scrollTarget') scrollTarget!: ElementRef;
  @ViewChild('scrollTarget2') scrollTarget2!: ElementRef;

  isScrolled: boolean = false;
  contentstats_data_types: any = null;
  contentstats_types: any = null;

  topValue : any = 10
  previousScrollPosition = 0 
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    // Check the scroll position and set isScrolled accordingly
    // const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    // if(this.showFilters){
    //   this.isScrolled = scrollPosition > 900; // Adjust the scroll threshold as needed
   
   
    // }
    // else  this.isScrolled = scrollPosition > 300;


    // const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // if (currentScrollPosition > this.previousScrollPosition) {

    //   this.topValue = this.topValue + 7
    // } else if (currentScrollPosition < this.previousScrollPosition) {
    //   if(this.topValue > 10){
    //      this.topValue = this.topValue - 7
    //   }
    // }

    // this.previousScrollPosition = currentScrollPosition;


    
    // let topClass =  document.querySelector('#topClass'). 
    // topClass
    

  }

  translator:TranslatorPipe = new TranslatorPipe()
  messages: Message[] = [];
  skelition: boolean = true
  currentRoute: any;
  showFilters: boolean = true
  @ViewChild('dv')
  dataView!: DataView;

  header = this.translate('Content update logs')
  links: link[] = [];
  breadcrumbs: breadcrumb[] = [{ name: this.translate('Content update logs'), link: '/admin/data/update' }];
  stats: stat[] = [];

  apilink = GlobalConstants.apiURL;
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  reason: any = undefined

  data: any
  filteredData: any

  pages: any[] = [];
  showing: string = '';
  currentPage: number = 1;
  totalPages: number = 0;
  totalRecords: number = 0;
  currentTypeFilter: any = 'all';

  page: number = 1;
  rows: number = 10;
  first = 1
  sortOrder: number = 1;
  sortField: string = '';


  currentLogs: any

  //filter options
  treeData: any[] = [];
  ouTypes: any;


  //Data Variables
  fieldTypes: any
  dataTypes: any

  rejectionModal = false

  parentOUS = [
    'الجهات المشاركة',
  ];

  //filter Variables
  LogsToshow: any
  statusOptions: any = [
    { name: 'PENDING', value: 1, arabic: this.translate('PENDING') },
    { name: 'APPROVED', value: 2, arabic: this.translate('APPROVED') },
    { name: 'REJECTED',value: 3, arabic: this.translate('REJECTED'), }
  ];
  typeOptions: any = [
    { name: 'ADD SERVICE', value: 1, arabic:  this.translate('Add data'), },
    { name: 'EDIT', value: 2, arabic: this.translate('Release') },
    { name: 'OU CHANGE', value: 3, arabic: this.translate('Change classification') },
    { name: 'DELETE', value: 3, arabic: this.translate('Delete') },
  ];

  getStatusArabic(): string | undefined {
    const status = this.statusOptions.find((option:any) => option.name === this.logStatus);
    return status ? status.arabic : undefined;
  }
  
  print(data:any) {
    console.log(data);
  }

  //filters
  typeFilter: any = undefined;
  oufilter: any = undefined;
  logType: any = undefined
  logStatus: any = 'PENDING'
  logStatus_set: any = 'PENDING'
  searchText: any = undefined
  start_date: any = undefined
  end_date: any = undefined

  selectedViewId : any = undefined

  side_view: any = undefined
  downloadExcel : boolean = false

  contentUpdateUsers : any
  updatedBy : any
  approvedBy : any
  allowedTypes:any[] = [];

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private orgUnits: OrgUnitsService,
    private permissionService: PermissionHandlerService,
    private exportService: ExportService,
  ) { }

  ngOnInit() {
    Promise.all([
      this.fetchDataType(),
      this.fetchFieldType(), this.getDataType(), this.getTreeData(), this.fetchDataFields(),this.fetchUsers()
    ]).then(e => { 
      this.getContentUpdates();
    });
  }

  hasPermission() {
    return this.permissionService.hasPermission('CONTENT_APPROVE', 'a');
  }


  getType(id: any) {
    return this.ouTypes.find((item: any) => item.value == id).label
  }

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  typeFilterLabel = null
  logTypeFilterLabel = null
  logStatusFilterLabel = "قيد الانتظار"

  //create query 
  generateQuery() {
    const queryRequest: any = {};

    if (this.typeFilter !== null && this.typeFilter !== undefined) {
      this.typeFilterLabel = this.getType(this.typeFilter)
      queryRequest.data_type = this.typeFilter;
    }

    if (this.oufilter !== null && this.oufilter !== undefined) {

      queryRequest.ous = this.oufilter._id;
    }

    if (this.logType !== null && this.logType !== undefined) {
      this.logTypeFilterLabel = this.typeOptions?.find((item: any) => item.name == this.logType).arabic
      queryRequest.type = this.logType;
    }

    if (this.logStatus !== null && this.logStatus !== undefined) {
      this.logStatusFilterLabel = this.statusOptions?.find((item: any) => item.name == this.logStatus).arabic
      queryRequest.status = this.logStatus;
    }

    if (this.searchText !== null && this.searchText !== undefined && this.searchText !== "") {
      queryRequest['$text'] = { $search: this.searchText };
    }

    if (this.start_date !== null && this.start_date !== undefined && (this.end_date == null || this.end_date == undefined)) {
      queryRequest.createdAt = {
        $gte: this.start_date,
      }
    }

    if (this.end_date !== null && this.end_date !== undefined && (this.start_date == null || this.start_date == undefined)) {
      queryRequest.createdAt = {
        $lte: this.end_date,
      }
    }

    if (this.end_date !== null && this.end_date !== undefined && this.start_date !== null && this.start_date !== undefined) {
      queryRequest.createdAt = {
        $gte: this.start_date,
        $lte: this.end_date
      }
    }

    if(this.updatedBy !== null && this.updatedBy !== undefined ){
      queryRequest.updated_by = this.updatedBy._id
    }

    if(this.approvedBy !== null && this.approvedBy !== undefined ){
      queryRequest.approved_by = this.approvedBy._id
    }

    return queryRequest
  }



  async getContentUpdates() {
    try {
      this.logStatus_set = this.logStatus;
      this.skelition = true;
      this.showFilters = true
      this.side_view = undefined

      let query = this.generateQuery();

      if(!query.data_type){
        query.data_type = { $in : this.allowedTypes}
      }

      if(!query.ous){
        let newOuArray  = this.flattenTree(this.selectedTreeData)
        query.ous =  newOuArray 
      }

      let res = await this.dataService.postData(`content-update/get?offset=${this.rows}&page=${this.page}`, query)

      console.log("RESOURCE", res);
      if (res.error) {
        return
      }
      this.data = res.data[0].data
      
      this.data.forEach((item:any)=>{
        if(item.type == "EDIT" && item.status == "PENDING" ){
          item.after.fields.forEach((item2:any)=>{
            item2.wasEdited = item2.isChecked;
          })
        }
      })

      console.log("==> isedited ",this.data)


      this.filteredData = this.data;
      this.totalRecords = res.data[0].total
      this.contentstats_data_types = res.data[0].data_type;
      this.contentstats_types = res.data[0].stats_type
      this.page = 1;
      this.rows = 10;
      this.skelition = false
    } catch (error) {
      console.log(error)
    }
  }

  //fetch content update users
  private async fetchUsers(): Promise<void> {
    let res = await this.dataService.getData('content-update/users');
   
    if (res.error) {
      return;
    }

    this.contentUpdateUsers = res.data[0];
    this.contentUpdateUsers.approved_by = this.contentUpdateUsers.approved_by.map((user:any) => {
      const fullName = `${user.name.first} ${user.name.middle} ${user.name.last}`;
      return { ...user, name: fullName };
    });
    this.contentUpdateUsers.updated_by = this.contentUpdateUsers.updated_by.map((user:any) => {
      const fullName = `${user.name.first} ${user.name.middle} ${user.name.last}`;
      return { ...user, name: fullName };
    });

    this.contentUpdateUsers

  }

  flattenTree(root: TreeNode[]): any[] {
    const result: any[] = [];
    root.map(e => this.flattenNode(e, result))
    // this.flattenNode(root, result);
    return result;
  }

  private flattenNode(node: TreeNode, result: any[]): void {
    result.push((node as any)?._id);
    if(node.children){
      for (const child of node.children) {
        this.flattenNode(child, result);
      }
    }
  }




  // onScroll() {
  //   const container: any = document.querySelector('.scroll-container'); // Adjust this selector as needed.
  //   if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
  //     // User has scrolled to the bottom, load more data.
  //     this.getContentUpdates();
  //   }
  // }

  openLog(data: any) {
    if (data?.type == 'ADD SERVICE'){
      this.side_view = data
      this.side_view.name = this.translate('No record found, newly created data.')
      this.selectedViewId = data._id
      // this.scrollToLog(data._id);

      // return
    } else {
      this.side_view = data.before?.dataview
      this.selectedViewId = data._id
      // this.scrollToLog(data._id);
      }
  }

  // async getTreeData() {
  //   this.treeData = await this.permissionService.extractOUChildren('CONTENT_UPDATE_LOGS', 'r');
  // }
  ngAfterViewChecked() {
    // if (this.selectedViewId !== undefined) {
    //   this.scrollToLog(this.selectedViewId);
    // }
  }
  

  // scrollToLog(logId: string) {
  //   const logElement = document.getElementById(logId);
  //   const scrollContainerElement = this.scrollTarget.nativeElement;
  
  //   if (logElement && scrollContainerElement) {
  //     // Calculate the target position with a slight offset from the top
  //     const offset = 85; // Adjust this value as needed to create space from the top
  //     const scrollPosition = logElement.offsetTop - offset;
  
  //     // Scroll the log element to the calculated position with smooth behavior
  //     scrollContainerElement.scrollTo({
  //       top: scrollPosition,
  //       behavior: 'smooth'
  //     });
  //   }
  // }



  getDataType = async () => {
    try {
      let res = await this.dataService.postData('data-type/get/', {
        active: true,
      });
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      this.allowedTypes = this.permissionService.extractTags('CONTENT_UPDATE_DATA_TYPE','r');
      this.ouTypes = res.data
      .filter((item: any) => this.allowedTypes.includes(item._id)) 
      .map((item: any) => ({
        label: item.arabic,
        value: item._id,
        icon: `pi pi-${item.icon}`,
      }));

    } catch (error) {
      console.log(error);
    }
  };

  private async fetchDataType(): Promise<void> {
    let res = await this.dataService.postData('data-type/get', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }

    this.dataTypes = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
      };
    });
  }

  dataFields: any = []
  private async fetchDataFields(): Promise<void> {
    let res = await this.dataService.postData('data-fields/get', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }

    this.dataFields = res.data;
  }

  //Get filed types
  private async fetchFieldType(): Promise<void> {
    let res = await this.dataService.postData('field-type/get/', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.fieldTypes = res.data
  }

  refresh() {
    this.typeFilterLabel = null
    this.logTypeFilterLabel = null
    this.logStatusFilterLabel = "قيد الانتظار"
    this.typeFilter = null;
   //debugger
    this.oufilter = undefined;
    this.start_date = undefined;
    this.end_date = undefined
    this.filteredData = this.data;
    this.logType = undefined,
    this.updatedBy = undefined,
    this.approvedBy = undefined
    this.start_date = undefined;
    this.end_date = undefined;
      // this.logStatus = 'PENDING'
    this.side_view = undefined
    this.getContentUpdates()
  }

  // filterData(data: any, key: any, value: any) {
  //   let results: any = [];

  //   function recursiveFilter(obj: any, parentObj = null) {
  //     if (Array.isArray(obj)) {
  //       obj.forEach((item) => recursiveFilter(item, parentObj));
  //     } else if (typeof obj === 'object') {
  //       if (obj != null && obj.hasOwnProperty(key) && obj[key] === value) {
  //         if (parentObj) {
  //           results.push(parentObj);
  //         }
  //         results.push(obj);
  //       }
  //       if (obj != null && obj != undefined)
  //         Object.values(obj).forEach((value) => recursiveFilter(value, obj));
  //     }
  //   }

  //   recursiveFilter(data);
  //   return results;
  // }

  applyOUPermission(data: any) {
    let result: boolean = false;
    for (let ou of data.breadcrumbs) {
      if (ou._id) {
        result = this.orgUnits.childrenContainsId(this.treeData, ou._id);
      } else {
        result = this.orgUnits.childrenContains(this.treeData, ou.name);
      }
      if (result) {
        break;
      }
    }
    return result;
  }

  changeToNumber(arg0: string): number {
    return Number(arg0);
  }

  applyFilterGlobal($event: any, stringVal: any) {
    console.log('KEY CEHCK', this.data);
    console.log($event.target.value);
    this.dataView.filter($event.target.value, stringVal);
  }


  applyTypeFilter(value: any) {
    if (this.currentTypeFilter != value) {
      this.currentTypeFilter = value;
    } else {
      this.currentTypeFilter = 'all';
    }

    console.log(value);
    if (this.currentTypeFilter == 'all') {
      this.dataView.filter('', 'contains');
    } else {
      this.dataView.filter(value, 'equals');
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['searchVal']) {
      const currentValue = changes['searchVal'].currentValue;
      console.log('CURRENT', currentValue);
      this.dataView.filter(currentValue, 'contains');
    }
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1
    this.getContentUpdates()
  }

  moveToLast(reverse: boolean) {
    if (reverse) {
      this.page = 0;
      this.rows = this.dataView.rows;
      this.currentPage = 1;
      this.dataView.paginate({ page: this.page, rows: this.rows })
    } else {
      const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
      this.page = (maxPage - 1) * this.dataView.rows;
      this.rows = this.dataView.rows;
      this.currentPage = maxPage;
      this.dataView.paginate({
        page: this.page,
        rows: this.rows
      });
    }
  }

  getFieldName(type: any) {
    return this.fieldTypes.find((item: any) => item._id == type).name
  }

  getFieldIcon(type: any) {
    return this.fieldTypes.find((item: any) => item._id == type).icon
  }

  getDataTypeIcon(id: any) {
    return this.dataTypes.find((item: any) => { return item._id == id }).icon
  }

  getDataTypeName(id: any) {
    return this.dataTypes.find((item: any) => { return item._id == id }).label
  }

  getDataTypeNameByDataFields(id: string) {
    return this.dataFields.find((item: any) => { return item._id == id }).type.name
  }


  //Get type of the filed
  getFieldType(type: any) {
    if (type._id) {
      type = type._id
    }
    if (this.fieldTypes == undefined) {
      this.fetchFieldType().then(() => {
        var result = this.fieldTypes.find((item: any) => item._id == type)?.name;
        return result;
      })
    } else {
      var result = this.fieldTypes.find((item: any) => item._id == type)?.name
      return result;
    }
  }

  //Approve log
  confirmApprove(logData: any) {
    let log: any = {
      _id: logData._id,
      type: logData.type,
      before: logData.before,
      after: logData.after,
      status: 'APPROVED'
    }

    if (logData.type != 'ADD SERVICE') log.service_id = logData?.service_id
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.ApproveLog(log),
    });
  }

   confirmReject() {
    this.rejectionModal = true;
  }

  //API Call Reject
  async RejectLog(logData: any) {
    try {

      if (!this.reason) return
      let log: any = {
        _id: logData._id,
        type: logData.type,
        before: logData.before,
        after: logData.after,
        status: 'REJECTED',
        reject_reason: this.reason
      }

      if (logData.type != 'ADD SERVICE') log.service_id = logData?.service_id

      let res = await this.dataService.postData('content-update/reject', log, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return
      }

      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];

      window.location.reload();
      this.reason = undefined;
      this.rejectionModal = false

      //Updating logs from front
      this.currentLogs.forEach((log: any) => {
        if (log._id === logData._id) {
          log.status = 'REJECTED';
        }
      });

      this.LogsToshow = this.LogsToshow.filter((log: any) => { return log._id !== logData._id });
      await this.getContentUpdates()
      // this.filterFunction()
    } catch (error) {
      console.log(error)
    }
  }

  //API Call Approve
  async ApproveLog(logData: any) {
    try {
      let res = await this.dataService.postData('content-update/approve', logData, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];

      window.location.reload()
      //Updating logs from front
      this.currentLogs.forEach((log: any) => {
        if (log._id === logData._id) {
          log.status = 'REJECTED';
        }
      });
      this.LogsToshow = this.LogsToshow.filter((log: any) => { return log._id !== logData._id });
      await this.getContentUpdates()
      // this.filterFunction()



    } catch (error) {
      console.log(error)
    }
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  currentview: any = {
    id: 0,
    name: 'لا توجد بيانات',
    breadcrumbs: [],
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  sortBreadcrums(data:any){
    return data.sort((a: any, b: any) => {
      return b.depth - a.depth;
    });
  }

  modalVisibilities: boolean[] = [];
  // Function to toggle modal visibility for a specific item.
  toggleModal(index: number) {
    this.modalVisibilities[index] = !this.modalVisibilities[index];
  }

  //service grt
  changeCurrentDataItem(dataItem: any, field: any, index: number) {
    field.data = dataItem
    this.toggleModal(index)
  }






  //Get tree data and as per the  permission
  async getTreeData() {
    this.treeData = await this.permissionService.extractOUChildren('CONTENT_UPDATE_LOGS', 'r');

    this.selectedTreeData_orginal = cloneDeep(this.treeData)
    this.changeSelectedTag(null);
    
    console.log("===>test data d",this.selectedTreeData);
  }


  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      // if (node._id === nodeName) {
      //   return node;
      // }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      "label": "Content Related"
    };
    if (this.selectedTreeTags_current.label) {
      console.log("change tag event1", event,this.selectedTreeData);
      await this.filterTreeByTag("Content Related");
    } else {
      this.selectedTreeData = null;
    }

  }

  
  selectedTreeData : any = []
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  filterTreeByTag(tag: string) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });

      console.log("cloneitems.children", cloneitems);
      this.selectedTreeData = cloneDeep(cloneitems);

      console.log("cloneitems.children this.selectedTreeData", this.selectedTreeData);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    // Recursively filter children nodes
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }



  exportData : any
  async getExportContentUpdates()  : Promise<any> {
    try {
      this.logStatus_set = this.logStatus;
      
      let query = this.generateQuery();

      if(!query.ous){
        let newOuArray  = this.flattenTree(this.selectedTreeData)
        query.ous =  newOuArray 
      }

      let res = await this.dataService.postData(`content-update/get?offset=${this.totalRecords}&page=${1}`, query)
      if (res.error) {
        return
      }
      // this.exportData = res.data[0].data
 

    let cleanedData: Array<any> = [];
    

    res.data[0].data.forEach((obj: any) => {

      let breakcrums = ''
      if(!!obj.before?.dataview){
        for(let i of this.sortBreadcrums(obj.before.dataview?.breadcrumbs)){
          if(breakcrums == ''){
            breakcrums = i.label
          } else  breakcrums = breakcrums + ' > ' + i.label
        }
      }
      
      let newObj: any = {
        'التاريخ' : obj?.createdAt?.substring(0,10),
        'طلب من قبل' : `${obj.updated_by?.name?.first} ${obj.updated_by?.name?.middle} ${obj.updated_by?.name?.last}`,
        'الوحدة التنظيمية' : breakcrums,
        'الحالة' : this.translate(obj.status),
        'الخدمات' : obj?.before?.dataview ? obj?.before?.dataview.type?.arabic : 'null',
        'النوع' : this.translate(obj.type),
        'اسم البيانات' : obj?.before?.name ?? obj?.before?.name ,
       

      };

      // Debugging: Check if fields exist
  console.log("Fields before processing:", obj.after?.fields);

  const convertHtmlToText = (html: string) => {
        return convert(html, {
            wordwrap: 130, // Preserve formatting width
            preserveNewlines: true, // Keeps new lines and spacing
        });
      };

  // Add dynamic fields from data.after.fields
  if (obj.after?.fields && Array.isArray(obj.after.fields)) {
    obj.after.fields.forEach((field: any) => {
      let fieldName = typeof field.label === "string" ? field.label : field.label?.name;
      if (fieldName && field?.data) {
        newObj[fieldName] = convertHtmlToText(field.data);
      }
    });
  }
     

      if(obj.type == 'ADD SERVICE'){
        newObj['اسم البيانات'] = obj?.after?.name
        newObj['الخدمات'] =  this.getDataTypeName(obj?.after.type)
      }

      if(obj.status == 'APPROVED'){
        newObj['الموافقة من قبل'] = obj.approved_by?.name?.first + obj.approved_by?.name?.middle + obj.approved_by?.name?.last
        newObj['تاريخ الموافقة'] = obj?.updatedAt?.substring(0,10)
      
      
      }

      if(obj.status == 'REJECTED'){
        newObj['الرفض من قبل'] = obj.approved_by?.name?.first + obj.approved_by?.name?.middle + obj.approved_by?.name?.last
        newObj['تاريخ الرفض'] = obj?.updatedAt?.substring(0,10)
      
      }

      cleanedData.push(newObj);
    });
    
    return cleanedData;
      
    } catch (error) {
      console.log(error)
    }
  }

  // public async cleanDataForContentUpdate(data: Array<any>): Promise<any> {
    
  //   await this.getExportContentUpdates()
    
  //   let cleanedData: Array<any> = [];

  //   this.exportData.forEach((obj: any) => {

  //     let breakcrums = ''
  //     for(let i of this.sortBreadcrums(obj.before.dataview?.breadcrumbs)){
  //       if(breakcrums == ''){
  //         breakcrums = i.label
  //       } else  breakcrums = breakcrums + ' > ' + i.label
  //     }

  //     let newObj: any = {
  //       'التاريخ' : obj?.createdAt?.substring(0,10),
  //       'طلب من قبل' : obj.updated_by.name.first + obj.updated_by.name.middle + obj.updated_by?.name?.last,
  //       'الوحدة التنظيمية' : breakcrums,
  //       'الحالة' : this.translate(obj.status),
  //       'الخدمات' : obj?.before?.dataview.type?.arabic,
  //       'النوع' : this.translate(obj.type),
  //       'اسم البيانات' : obj?.before?.name ,
       

  //     };

  //     if(obj.status == 'APPROVED'){
  //       newObj['الموافقة من قبل'] = obj.approved_by.name.first + obj.approved_by.name.middle + obj.approved_by?.name?.last
  //       newObj['تاريخ الموافقة'] = obj?.updatedAt?.substring(0,10)
      
      
  //     }

  //     if(obj.status == 'APPROVED'){
  //       newObj['الرفض من قبل'] = obj.approved_by.name.first + obj.approved_by.name.middle + obj.approved_by?.name?.last
  //       newObj['تاريخ الرفض'] = obj?.updatedAt?.substring(0,10)
      
  //     }

  //     cleanedData.push(newObj);
  //   });
  //   return cleanedData;
  // }


  public async exportExcel() {
    this.downloadExcel = true
    let  cleanData =  await this.getExportContentUpdates()
    cleanData
  
    this.exportService.exportContentUpdateExcel(cleanData);
    this.downloadExcel = false
  }

  protected confirmUndoDelete(log: any){
    
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.undoDelete(log),
    });
  }

  private async undoDelete(log:any){
    try {
      
      let data : any = {
        _id : log._id,
        service_id : log.service_id
      }

      let res = await this.dataService.postData('content-update/undo-delete',data,'PUT',false)

      if(res.error) return

      this.cleanOu(log.ous)
      
      await this.getContentUpdates()
      
    } catch (error) {
      console.log(error)
    }
  }

  async cleanOu(ous : any){
    try {
      let res = await this.dataService.postData('data/ou-clean',ous)
      if(res.error) return false
      return true
    } catch (error) {
      return error
    }
  }


}
